/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SearchResultBarContent_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchResultBar_viewer$ref: FragmentReference;
declare export opaque type SearchResultBar_viewer$fragmentType: SearchResultBar_viewer$ref;
export type SearchResultBar_viewer = {|
  +$fragmentRefs: SearchResultBarContent_viewer$ref,
  +$refType: SearchResultBar_viewer$ref,
|};
export type SearchResultBar_viewer$data = SearchResultBar_viewer;
export type SearchResultBar_viewer$key = {
  +$data?: SearchResultBar_viewer$data,
  +$fragmentRefs: SearchResultBar_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SearchResultBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "params",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SearchResultBarContent_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "params",
          "variableName": "params"
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b4bcc49824f8996eae8af4b418656657';
module.exports = node;
